import React, { useState, useCallback } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import { FileDownload } from '@mui/icons-material'
import { api } from '../../services/Main/Api'
import { useSnackbar } from 'notistack'
import { getFilenameFromDisposition } from '../../helpers/formatters'

const FORMAT_OPTIONS = [
    { label: 'Excel (.xlsx)', value: 'xlsx' },
    { label: 'CSV (.csv)', value: 'csv' },
]

const ExportDropdownButton = ({ endpoint, buildParams, defaultFilename = 'export', buttonProps = {} }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [exporting, setExporting] = useState(false)
    const { enqueueSnackbar } = useSnackbar()
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleExport = useCallback(async (format) => {
        setAnchorEl(null)
        try {
            setExporting(true)

            const baseParams = buildParams()
            let params
            if (baseParams instanceof URLSearchParams) {
                params = baseParams
                params.append('file_format', format)
            } else {
                params = { ...baseParams, file_format: format }
            }

            const response = await api.get(endpoint, {
                params,
                responseType: 'blob',
            })

            const disposition = response.headers?.['content-disposition']
            const filename = getFilenameFromDisposition(disposition)
                || `${defaultFilename}.${format}`

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(blobUrl)

            enqueueSnackbar('Exportação concluída!', { variant: 'success' })
        } catch (err) {
            console.error('Erro ao exportar:', err)
            enqueueSnackbar('Erro ao exportar. Tente novamente.', { variant: 'error' })
        } finally {
            setExporting(false)
        }
    }, [endpoint, buildParams, defaultFilename, enqueueSnackbar])

    return (
        <>
            <Button
                variant="outlined"
                size="small"
                startIcon={<FileDownload />}
                onClick={handleClick}
                disabled={exporting}
                {...buttonProps}
            >
                {exporting ? 'Exportando...' : 'Exportar'}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {FORMAT_OPTIONS.map((option) => (
                    <MenuItem
                        key={option.value}
                        onClick={() => handleExport(option.value)}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default ExportDropdownButton
